<template>
    <v-container>
        <template>
            <v-row justify="center">
                <v-dialog
                    v-model="deleteDialog"
                    persistent
                    max-width="290"
                >
                    <v-card>
                        <v-card-text class="headline">
                            Are you sure you want to delete this file ?
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="accent"
                                @click="deleteDialog = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                color="info"
                                :loading="deleting"
                                @click="deleteFile()"                                              
                            >
                                Confirm
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <template>
            <v-row>
                <v-dialog v-model="previewPDFDialog" v-if="previewPDFDialog" fullscreen>
                    <v-card>
                        <v-toolbar
                            dark
                            color="primary"
                        >
                            <v-btn
                                icon
                                dark
                                @click="previewPDFDialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Preview</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <PreviewPDF :filePath="previewFilePath" :loading="previewing" :isPDF="isPDF"> </PreviewPDF>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-data-table v-else
            :items="files"
            :items-per-page="20"
            :footer-props="{ 'items-per-page-options': [10,20,50,-1] }"
            :headers="mainHeaders"
            show-expand
            :expanded.sync="expanded"
            item-key="DocumentID"
            sort-by="DocumentID"
            :sort-desc="true">
        
            <template v-slot:item.Preview="{ item }">
                <v-btn
                    v-if="item.S3Path"
                    color="info"
                    @click="preview(item.S3Path)">Preview</v-btn>
            </template>
            <template v-slot:item.Delete="{ item }">
                <v-btn
                    v-if="permission"
                    color="accent"
                    :loading="deleting"
                    :disabled="deleting"
                    @click="showDeleteDialog(item)">Delete</v-btn>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import * as venomPoolingAPI from '@/services/venomPoolingAPI';
import fileService from "../../services/fileService";
import PreviewPDF from ".././venomanalysis/PreviewPDF"

export default {

     components: {
        PreviewPDF
    },
    props: {
        monthlyPoolID: {
            type: Number,
            default: -1
        },
    },
    data() {
        return {
            loading: false,
            previewing:false,
            previewPDFDialog:false,
            previewFilePath:"",
            isPDF:true,
            files: [],
            loadingError: "",
            deleteDialog:false,
            deleteItem:null,
            deleting:false,

            mainHeaders: [
                {
                    text: "FileName",
                    value: "FileName"
                },
                {
                    text: "Description",
                    value: "Description"
                },
                {
                    text: "Comments",
                    value: "Comments"
                },
                {
                    text: "",
                    value: "Preview",
                    class: "min-width-column"
                },
                {
                    text: "",
                    value: "Delete",
                    class: "min-width-column"
                },
                { 
                    text: '', 
                    value: 'data-table-expand' 
                }
            ]
        };
    },
    computed:{
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        }
    },
    methods: {
        async preview(s3Path) {

            this.previewPDFDialog = true;
            if(!(s3Path.toLowerCase().includes("pdf"))){
                this.previewFilePath = "";
                this.isPDF = false;
            }
            else{

                this.isPDF = true;
                this.previewing = true;

                var filePath = await fileService.getDownloadURL(s3Path);
                
                this.previewing = false;
                this.previewFilePath = filePath; 
            }
                   
        },
        async loadFiles() {
            this.loading = true;
            this.loadingError = "";

            try {
                this.files = await venomPoolingAPI.getMonthlyPoolDocuments(this.monthlyPoolID);
                this.expanded = [ this.files[0] ]
            } catch (e) {
                this.loadingError = e.message
            }

            this.loading = false;
            
        },
        async deleteFile(){
            this.deleting = true;
            try {
                //delete file
                if(this.deleteItem.S3Path != null){
                  
                    await venomPoolingAPI.deleteMonthlyPoolDocument(this.deleteItem.S3Path,this.deleteItem.DocumentID);
                }
            } 
            catch (e) {
                this.loadingError = e.message
            }
            this.deleteDialog = false;
            this.deleting = false;
            this.loadFiles();

        },
        showDeleteDialog(item){

            this.deleteItem = item;
            this.deleteDialog = true;
     },
},

async created() {
        await this.loadFiles();
},

}
</script>

<style>
    .min-width-column {
        width: 1%;
    }
</style>

<style scoped>
    .expansion-panel {
        background-color: white;
    }
</style>